import React from 'react';
import { CircleX } from 'lucide-react';

import { Button } from '@epoch-ui/components/Button';
import { useDeleteDraftEventModal } from '@event-editor/hooks/eventEditorState';

const DeleteDraftEventSection = (): React.ReactElement => {
  const deleteDraftEventModal = useDeleteDraftEventModal();

  return (
    <div>
      <div className="tw-flex tw-items-start tw-justify-between">
        <div>
          <h2 className="tw-m-0 tw-text-xl tw-font-medium tw-leading-7">Delete draft event</h2>
        </div>
      </div>

      <div className="tw-mt-1 tw-space-y-5">
        <p className="tw-m-0 tw-text-sm tw-font-normal tw-leading-5 tw-text-primary-grey">
          Deleting this draft event will remove it from Epoch. You can’t undo this action.
        </p>

        <Button
          variant="destructive"
          size="sm"
          className="tw-rounded-xl"
          onClick={deleteDraftEventModal.open}
        >
          <CircleX className="tw-mr-2 tw-h-4 tw-w-4" />
          Delete draft
        </Button>
      </div>
    </div>
  );
};

export { DeleteDraftEventSection };
